import type { BotIdTags } from "../types";

function getTagsFromBotId(verification: {
  isHuman: boolean;
  isBot: boolean;
  isGoodBot?: boolean;
  isVerifiedBot?: boolean;
}): BotIdTags {
  // DD tags - https://docs.datadoghq.com/getting_started/tagging/
  // combined with what we're using in logError
  return {
    botid_bot: verification.isBot,
    botid_goodbot:
      verification.isGoodBot ?? verification.isVerifiedBot ?? false,
    botid_human: verification.isHuman,
  };
}

export { getTagsFromBotId };
